import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';

import * as LookupActions from '../../../actions/lookupActions';

import * as classes from './LookupManagement.module.css';

const LookupManagement = ({
    activeNavCompany,
    equipmentTypes,
    fetchSensorTypes,
    fetchEquipmentTypes,
    sensorTypes,
    ...props
}) => {

    useEffect(() => {
        const init = async () => {
            await Promise.all([fetchSensorTypes(), fetchEquipmentTypes()].map(p => p.catch(err => err)));
        };

        if (isEmpty(sensorTypes) || isEmpty(equipmentTypes)) {
            init();
        }
    }, [activeNavCompany.id]);

    return (
        <BobPage>
            <div className={classes.LookupPage}>
                <div className={classes.CompanyNamePanel}>
                    {activeNavCompany.name}
                </div>
                <div className={classes.HeaderPanel}>
                    Sensor Types
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    <TableContainer />
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    equipmentTypes:   state.lookup.equipmentTypes,
    sensorTypes:      state.lookup.sensorTypes
});

const mapDispatchToProps = {
    ...LookupActions
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupManagement);
